<script setup lang="ts">
import loader from '~/assets/icons/loader.svg';
</script>

<template>
    <span
        class="inline-flex size-(--edito-loader-size) items-center justify-center align-middle [--edito-loader-size:2.5rem]"
        role="status"
        :aria-label="$t('[[[Ładowanie]]]')"
    >
        <img
            class="size-full"
            :src="loader"
            alt=""
            aria-hidden="true"
        >
    </span>
</template>
